<!--
    BD Write-Off Dialog — Wave 4.1
    p-dialog mit Abschreibungsgrund-Auswahl, Saldo-Anzeige und Pflicht-Begruendung.
    Bei Bestaetigung wird decideManualContractDecision mit action='WRITE_OFF' aufgerufen.
    @ticket TM-1000001782
-->
@if (initialized) {
    <p-dialog
            [(visible)]="visible"
            [modal]="true"
            [closable]="true"
            [closeOnEscape]="true"
            [dismissableMask]="false"
            [style]="{width: '36rem'}"
            header="Forderung abschreiben"
            (visibleChange)="onVisibleChange($event)">

        <div class="flex flex-column gap-3 p-2">

            <!-- Mahnungs-Info -->
            <div class="surface-card border-round p-3 flex flex-column gap-2">
                <div class="flex align-items-center gap-2">
                    <i class="fa-regular fa-user text-primary"></i>
                    <span class="font-semibold">Kunde:</span>
                    <span>{{ customerName }}</span>
                </div>
                <div class="flex align-items-center gap-2">
                    <i class="fa-regular fa-file-lines text-primary"></i>
                    <span class="font-semibold">Mahn-Typ:</span>
                    <span>{{ dunningTypeName }}</span>
                </div>
                <div class="flex align-items-center gap-2">
                    <i class="fa-regular fa-layer-group text-primary"></i>
                    <span class="font-semibold">Aktive Stufe:</span>
                    <span>{{ activeLevelLabel }}</span>
                </div>
            </div>

            <!-- Hinweis -->
            <p-message
                    severity="warn"
                    text="Die Forderung wird endgültig abgeschrieben. Diese Aktion ist nicht umkehrbar."
                    styleClass="w-full">
            </p-message>

            <!-- Abschreibungsbetrag (read-only) -->
            <div class="flex flex-column gap-1">
                <label class="block text-sm font-medium">Abschreibungsbetrag</label>
                <div class="surface-50 border-round p-3 font-semibold text-color">
                    {{ balanceLabel }}
                </div>
            </div>

            <!-- Abschreibungsgrund -->
            <div class="flex flex-column gap-1">
                <label class="block text-sm font-medium">
                    Abschreibungsgrund <span class="text-red-500">*</span>
                </label>
                <p-select
                        [options]="reasonOptions"
                        optionLabel="label"
                        optionValue="value"
                        [(ngModel)]="selectedReason"
                        placeholder="Bitte wählen…"
                        appendTo="body"
                        styleClass="w-full">
                </p-select>
            </div>

            <!-- Begruendung (Pflicht) -->
            <div class="flex flex-column gap-1">
                <label class="block text-sm font-medium">
                    Begründung <span class="text-red-500">*</span>
                </label>
                <textarea
                        pTextarea
                        rows="3"
                        [(ngModel)]="comment"
                        placeholder="Bitte ausführlich begründen…"
                        class="w-full">
                </textarea>
            </div>

            <!-- Error -->
            @if (errorMessage) {
                <p-message
                        severity="error"
                        [text]="errorMessage"
                        styleClass="w-full">
                </p-message>
            }
        </div>

        <!-- Footer -->
        <ng-template #footer>
            <div class="flex justify-content-end gap-2 w-full">
                <p-button
                        label="Abbrechen"
                        severity="secondary"
                        [disabled]="submitting"
                        (onClick)="onCancel()">
                </p-button>
                <p-button
                        label="Bestätigen"
                        icon="fa-regular fa-eraser"
                        severity="danger"
                        [loading]="submitting"
                        [disabled]="selectedReason === null"
                        (onClick)="confirm()">
                </p-button>
            </div>
        </ng-template>
    </p-dialog>
}
